import { ADMIN_TICKETS } from '../../types';

export default {
  state: {
    ticketsQuery: null,

  },
  getters: {
    ticketsData(state) {
      if (!state.ticketsQuery) {
        return null;
      }
      return state.ticketsQuery.data || null;
    },
  },
  mutations: {
    [ADMIN_TICKETS.SET_TICKETS_QUERY](state, payload) {
      state.ticketsQuery = payload;
    },

  },
  actions: {

  },

};
